import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Footer() {

    const location = useLocation();

    const hideFooter = useMemo(() => {
        return [
            '/tutorial',
            '/login',
        ].includes(location.pathname);
    }, [location.pathname]);
    const activeLocation = useMemo(() => {
        const path = location.pathname;
        if (['/edit-profile', '/wallet', '/rules'].includes(path)) return 'profile';
        //else if (path === '/about') return 'about';
        else if (path === '/') return 'home';
        return 'crash';
    }, [location.pathname]);
    
    return (
        !hideFooter &&
        <div className='footer'>
            <Link
                className={activeLocation === 'crash' ? 'link active' : 'link'}
                to='/report-list'
            >
                {/* <i className='fas fa-info-circle' /> */}
                <i className='fas fa-car-crash' />
            </Link>
            <Link
                className={activeLocation === 'home' ? 'link active' : 'link'}
                to='/'
            >
                {/* <i className='fas fa-car-crash' /> */}
                <i className='fas fa-home' />
            </Link>
            <Link
                className={activeLocation === 'profile' ? 'link active' : 'link'}
                to='/edit-profile'
            >
                <i className='fas fa-user' />
            </Link>
        </div>
    );
    
}
